import { render, staticRenderFns } from "./Deck.vue?vue&type=template&id=abfb0adc"
import script from "./Deck.vue?vue&type=script&lang=js"
export * from "./Deck.vue?vue&type=script&lang=js"
import style0 from "./Deck.vue?vue&type=style&index=0&id=abfb0adc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports